import { Badge, Group, Paper, Stack, Table, Text } from '@mantine/core';
import {
  ProposalDraftStorageType,
  ProposalDraftSummaryItemType,
} from '../../../../../business/proposals/draft';

type ProposalDraftConfirmContentProps = {
  draft: ProposalDraftStorageType;
  summary: ProposalDraftSummaryItemType[];
};

function ProposalDraftConfirmContent({ draft, summary }: ProposalDraftConfirmContentProps) {
  const savedAt = draft.savedAt
    ? new Date(draft.savedAt).toLocaleString('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'short',
      })
    : null;

  return (
    <Stack gap="md">
      <Text size="sm">
        Existe um rascunho salvo para esta proposta. Você pode carregá-lo para continuar a edição ou
        excluí-lo.
      </Text>

      <Paper withBorder p="sm">
        <Group justify="space-between">
          <Text size="sm" fw={500}>
            Resumo das alterações
          </Text>
          {savedAt && <Badge variant="light">Salvo em {savedAt}</Badge>}
        </Group>

        <Text size="xs" c="dimmed" mt={4}>
          Dados gerais e condições comerciais também podem conter alterações não salvas.
        </Text>

        {summary.length > 0 ? (
          <Table mt="sm" withTableBorder withColumnBorders striped>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Grupo</Table.Th>
                <Table.Th ta="center">Adicionar</Table.Th>
                <Table.Th ta="center">Alterar</Table.Th>
                <Table.Th ta="center">Excluir</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {summary.map((item) => (
                <Table.Tr key={item.label}>
                  <Table.Td>{item.label}</Table.Td>
                  <Table.Td ta="center">{item.add || '-'}</Table.Td>
                  <Table.Td ta="center">{item.modify || '-'}</Table.Td>
                  <Table.Td ta="center">{item.delete || '-'}</Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        ) : (
          <Text size="sm" mt="sm">
            Nenhuma alteração identificada.
          </Text>
        )}
      </Paper>
    </Stack>
  );
}

export default ProposalDraftConfirmContent;
